<div uk-grid>
  <div class="uk-width-1-1">
    <h2>Keypair Generator</h2>

    <div class="uk-card uk-card-default">
      <div class="uk-card-header" style="border-bottom: none">
        <p>This tool generates seeds, mnemonic phrases and private key / public address pairs using a cryptographically secure random hash function.<br>
          You will need to manually store the recovery options for each generated address that you want to retain access to.</p>
        <div>
          <ul>
            <li>The account can receive incoming funds at any time and live transactions can happen in any wallet that supports import of nano secret recovery seed/mnemonic or private key.</li>
            <li>For additional security the keys can be generated and stored offline to be utilized in methods such as <a routerLink="/remote-signing" class="name">Remote Signing</a> and <a routerLink="/multisig" class="name">Multisig</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="uk-card uk-card-default" style="margin-top: 20px;">
      <div class="uk-card-header">
        <h3 class="uk-card-title">Generate a new random keypair</h3>
        <p>For <strong>Remote Signing</strong> or <strong>Multisig</strong>, you will need to store and use the <strong>Private Key</strong>.</p>
      </div>
      
      <div class="uk-card-body">
        <div uk-grid>
          <div class="uk-width-1-4@m">{{ 'configure-wallet.new-wallet.secret-recovery-seed' | transloco }} <span uk-icon="icon: info;" uk-tooltip title="Can be used to derive many private keys with different indexes or converted to a secret recovery mnemonic. It's NOT bip39/44."></span></div>
          <div class="uk-width-3-4@m">
            <div *ngIf="seed == ''" class="uk-margin-small-bottom">...</div>
            <div *ngIf="seed !== ''">
              <div class="uk-margin-small-bottom word-wrap-anywhere">{{ seed }}</div>
              <a [title]="( 'configure-wallet.new-wallet.copy-secret-recovery-seed' | transloco )" ngxClipboard [cbContent]="seed" (cbOnSuccess)="copied()" uk-tooltip>{{ 'configure-wallet.new-wallet.copy-secret-recovery-seed' | transloco }}</a>
            </div>
          </div>
        </div>
        <hr class="uk-divider-icon">
    
        <div uk-grid>
          <div class="uk-width-1-4@m">
            {{ 'configure-wallet.new-wallet.secret-recovery-mnemonic' | transloco }} <span uk-icon="icon: info;" uk-tooltip title="Can be used to derive many private keys with different indexes or converted to a secret recovery seed. It's NOT bip39/44."></span>
          </div>
          <div class="uk-width-3-4@m">
            <div *ngIf="mnemonic == ''" class="uk-margin-small-bottom">...</div>
            <div *ngIf="mnemonic !== ''">
              <pre class="mne-box"><span *ngFor="let line of newWalletMnemonicLines; let l = index" class="mne-cont"><span *ngFor="let word of line; let i = index" class="mne-word"><span class="mne-num">{{ (l * 4) + i + 1 }}</span> {{ word }}</span></span></pre>
              <a [title]="('configure-wallet.new-wallet.copy-secret-recovery-mnemonic' | transloco)" ngxClipboard [cbContent]="mnemonic" (cbOnSuccess)="copied()" uk-tooltip>{{ 'configure-wallet.new-wallet.copy-secret-recovery-mnemonic' | transloco }}</a>
            </div>
          </div>
        </div>
        <hr class="uk-divider-icon">
    
        <div uk-grid>
          <div class="uk-width-1-4@m">
            Private Key - Index 0
          </div>
          <div class="uk-width-3-4@m">
            <div *ngIf="privateKey == ''" class="uk-margin-small-bottom">...</div>
            <div *ngIf="privateKey !== ''">
              <div class="uk-margin-small-bottom word-wrap-anywhere">{{ privateKey }}</div>
              <a title="Copy Private Key" ngxClipboard [cbContent]="privateKey" (cbOnSuccess)="copied()" uk-tooltip>Copy Private Key</a>
            </div>
          </div>
        </div>
        <hr class="uk-divider-icon">
        
        <div *ngIf="account !== ''">
          <div class="uk-alert uk-alert-danger nlt-inline-alert">
            <div class="icon-column">
              <div uk-icon="icon: warning; ratio: 2;"></div>
            </div>
            <p>
              You will NOT be able to access any funds on the address below, without a secret recovery seed/mnemonic or a private key written above.<br>
              Make sure to securely store any of the secret recovery seed, mnemonic or private key, save it somewhere safe and <strong>never share it with anyone!</strong>
            </p>
          </div>
        </div>
        <br>

        <div uk-grid>
          <div class="uk-width-1-4@m">
            Address - Index 0
          </div>
          <div class="uk-width-3-4@m uk-text-truncate">
            <div *ngIf="account == ''" class="uk-margin-small-bottom">...</div>
            <div *ngIf="account !== ''">
              <div class="uk-margin-small-bottom"><app-nano-account-id [accountID]="account" middle="auto" class="nano-address-monospace"></app-nano-account-id></div>
              <a title="Copy Address" ngxClipboard [cbContent]="account" (cbOnSuccess)="copied()" uk-tooltip>Copy Address</a>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-footer uk-text-left nlt-button-group">
        <button class="uk-button uk-button-primary uk-width-auto@s uk-width-1-1" (click)="generate()">Generate New Keypair</button>
      </div>
    </div>
  </div>
</div>
